import {
	MyAppointmentsEnum,
	HomeEnum,
	HealthCardEnum,
	HelpCenterEnum,
	MyPaymentsEnum,
	ProfileEnum,
	ConsultProtocolsEnum,
	ExamResultsEnum,
	RefundEnum,
	AuthorizationsEnum,
	MyReferralsEnum,
	ServicesEnum,
	NotificationsEnum,
} from './mapRoutesEnum';

export const CONGENERE_ROUTES: string[] = [
	HomeEnum.HOME_PAGE,
	HealthCardEnum.HEALTH_CARD,
	HelpCenterEnum.HELP,
	HelpCenterEnum.SEND_MESSAGE,
	HelpCenterEnum.SERVICE_POINTS_ADDRESSES,
	ProfileEnum.PROFILE,
	ConsultProtocolsEnum.CONSULT_PROTOCOLS,
	MyAppointmentsEnum.MY_APPOINTMENTS,
	MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_HEALTH,
	MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_TELEHEALTH,
	MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_ODONTO,
	MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_EXAM,
	MyAppointmentsEnum.MY_APPOINTMENTS_DETAILS_SURGERY,
	MyAppointmentsEnum.MY_APPOINTMENTS_HISTORY,
	MyAppointmentsEnum.MY_APPOINTMENTS_HISTORY_DETAILS,
	MyAppointmentsEnum.MY_APPOINTMENTS_HISTORY_SURGERY_DETAILS,
	MyPaymentsEnum.INCOME_TAX,
	MyPaymentsEnum.OPEN_BILLS,
	MyPaymentsEnum.BILLET_DETAILS,
	MyPaymentsEnum.PAYMENTS_HISTORY,
	ExamResultsEnum.EXAM_RESULTS,
	ExamResultsEnum.EXAM_RESULTS_DETAILS,
	ExamResultsEnum.EXAM_RESULTS_WAITING,
	RefundEnum.REFUND,
	RefundEnum.REQUEST,
	RefundEnum.REQUEST_PREVIEW,
	RefundEnum.CONSULT,
	RefundEnum.CONSULT_PREVIEW,
	RefundEnum.SENDING_DOCUMENTS,
	RefundEnum.TERMS_PREVIEW,
	RefundEnum.TERMS_DEFAULT,
	RefundEnum.TERMS_ADDITIONAL_DOCS,
	RefundEnum.TERMS,
	AuthorizationsEnum.AUTHORIZATIONS_ODONTO,
	AuthorizationsEnum.AUTHORIZATIONS,
	AuthorizationsEnum.AUTHORIZATIONS_REQUESTS,
	AuthorizationsEnum.REQUEST_DETAIL,
	AuthorizationsEnum.INSTRUCTIONS,
	MyReferralsEnum.MY_REFERRALS,
	MyReferralsEnum.MY_REFERRALS_HISTORY,
	ServicesEnum.SERVICES,
	NotificationsEnum.NOTIFICATIONS,
];
